import Vue from 'vue'

let getRules = (self) => {
  let parent = self.parent.$el
  let rules = {}
  // 获取所有表单验证提示错误信息
  let formItem = parent.querySelectorAll('.el-form-item')
  if (formItem && Array.from(formItem).length) {
    Array.from(formItem).forEach(item => {
      const t = item.__vue__
      if (t && t.prop) {
        rules[t.prop] = {
          msg: t.validateMessage,
          width: t.$attrs.errorPopWidth || t.$attrs['error-pop-width'],
          position: t.$attrs.errorPopPosition || t.$attrs['error-pop-position']
        }
      }
    })
  }
  return rules
}

const KyeForm = Vue.component('kye-form', {
  functional: true,
  render (h, self) {
    let labelWidth = self.props.labelWidth || '64px'
    let noErrorPop = self.props.noErrorPop || false
    self.data.attrs = { ...self.data.attrs, labelWidth, noErrorPop }
    self.data.on = {
      update: (model) => {
        self.listeners['update:model'](model)
      },
      validate: (field, isRequired, msg) => {
        let parent = self.parent.$el
        let addHtml = () => {
          let error = parent.querySelector('.el-form-item__error')
          if (error) {
            let rules = getRules(self)
            let text = error.innerText
            let obj = null
            // 校验过程时，当前字段不一定是气泡显示字段，需对比字段，拿到el-form-item上的属性
            for (let key in rules) {
              if (rules[key].msg === text) {
                obj = rules[key]
              }
            }
            let className = 'el-form-item__error-pop__arrow-top'
            if (obj && obj.width) {
              error.style.width = parseInt(obj.width) + 'px'
            }
            if (obj && obj.position && obj.position === 'top') {
              self.parent.$nextTick(() => {
                error.style.top = -(error.offsetHeight + 6) + 'px'
                error.style.marginTop = '0px'
              })
              className = 'el-form-item__error-pop__arrow-bottom'
            }
            let span = document.createElement('span')
            span.className = className
            error.classList.add('el-form-item__error-pop')
            error.appendChild(span)
          }
        }

        if (!noErrorPop) {
          self.parent.$nextTick(() => {
            // 校验通过
            if (isRequired) {
              setTimeout(() => {
                addHtml()
              }, 200)
            } else {
              // 校验不通过, 需删除所有dom重新增加，需重新找到首个进行校验
              let popDom = parent.querySelector('.el-form-item__error-pop')
              if (popDom) {
                popDom.style = ''
                popDom.classList.remove('el-form-item__error-pop')
                let span = popDom.querySelectorAll('span')
                Array.from(span).forEach(node => {
                  popDom.removeChild(node)
                })
              }
              addHtml()
            }
          })
        }
      },
      decrypt: (...arg) => {
        const decrypt = self.listeners.decryptSuccess
        if (typeof decrypt === 'function') {
          decrypt(...arg)
        }
      }
    }
    return h('el-form', self.data, self.children)
  }
})

export default KyeForm



// WEBPACK FOOTER //
// ./src/public/components/kye-form/index.js